import { NotificationType } from '@capacitor/haptics';
import { Log } from '.';
import { Language, Role } from '../enums';
import { MyProfile } from './my-profile';

export interface User extends Log {
    id?: any;
    /**
     * @description Email used for register or create user.
     * Must be unique or else will throw E11000 duplicate key error. Email will be used later for log in.
     */
    email?: string;

    /**
     * @description Password who will be used for log in user account
     */
    password?: string;

    /**
     * @description Language for account. By default is En.
     */
    language?: Language;

    /**
     * @description Account role like User or Admin. In user route 'register'  you can create only with user role.
     * In admin route 'create-user' you can give admin role to another user.
     */
    roles?: Role[];

    /**
     * @Description : This is the My Profile Page
     */
    myProfile?: MyProfile;

    /**
     * @description used mostly to identify requests of public user
     */
    deviceId?: string;

    /**
     * @description indicates if the user is public or registered
     */
    isPublic?: boolean;

    /**
     * @description the woocommerce customer id
     */
    wooCustomerId?: string;

    /**
     * If true, the data was already requested
     */
    dataRequested?: boolean;

    notificationStatuses?: NotificationStatus[];

    voucherIds?: string[];
}

export interface NotificationStatus {
    type: NotificationType;
    lastNotifiedAt: Date;
}
